// ** React Imports
import { Navigate } from 'react-router-dom'
import { useContext, Suspense } from 'react'
import { useSelector } from 'react-redux'

// ** Context Imports
import { AbilityContext } from '@src/utility/context/Can'

// ** Utils
import { hasRequiredRoles } from '@src/utility/roleUtils'
import { selectUserRoles, selectIsAuthenticated } from '@src/redux/slices/authSlice'

// ** Spinner Import
import Spinner from '../spinner/Loading-spinner'

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const ability = useContext(AbilityContext)
  const userRoles = useSelector(selectUserRoles)
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const user = JSON.parse(localStorage.getItem('userData') || 'null')

  if (route) {
    let action = null
    let resource = null
    let restrictedRoute = false
    let requiredRoles = null

    if (route.meta) {
      action = route.meta.action
      resource = route.meta.resource
      restrictedRoute = route.meta.restricted
      requiredRoles = route.meta.requiredRoles
    }
    
    // Verificar autenticação
    if (!user || !isAuthenticated) {
      return <Navigate to='/login' />
    }
    
    // Verificar se rota é restrita
    if (restrictedRoute) {
      return <Navigate to='/' />
    }
    
    // Verificar roles requeridos (prioridade sobre CASL)
    if (requiredRoles && Array.isArray(requiredRoles) && requiredRoles.length > 0) {
      if (!hasRequiredRoles(userRoles, requiredRoles)) {
        return <Navigate to='/misc/not-authorized' replace />
      }
    }
    
    // Verificar permissões CASL (se não tiver requiredRoles ou se tiver action/resource)
    if (action && resource && !ability.can(action || 'read', resource)) {
      // Se for admin, permitir acesso mesmo sem permissão específica
      if (userRoles && userRoles.includes('admin')) {
        // Admin tem acesso
      } else {
        return <Navigate to='/misc/not-authorized' replace />
      }
    }
  }

  return <Suspense fallback={<Spinner className='content-loader' />}>{children}</Suspense>
}

export default PrivateRoute
